import { render, staticRenderFns } from "./Painel.vue?vue&type=template&id=257e31f2&scoped=true&"
import script from "./Painel.vue?vue&type=script&lang=js&"
export * from "./Painel.vue?vue&type=script&lang=js&"
import style0 from "./Painel.vue?vue&type=style&index=0&id=257e31f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257e31f2",
  null
  
)

export default component.exports